import { Skeleton } from 'antd';
import styled from 'styled-components';

import { CSS_PREFIX } from '@/constants/styles';
import { BlueColors, NeutralColors } from '@/theme';

export const Trigger = styled.button<{ $hasIcon: boolean; $isOpen: boolean }>`
  display: flex;
  align-items: center;
  max-width: 300px;
  padding: 4px;
  padding-right: 16px;
  border: 2px solid
    ${({ $isOpen }) => ($isOpen ? BlueColors[50] : NeutralColors[40])};
  border-radius: 40px;
  background: ${({ $isOpen }) => ($isOpen ? BlueColors[10] : NeutralColors[0])};
  cursor: pointer;
  text-align: left;

  &:focus-visible {
    border-color: ${BlueColors[50]};
  }

  .${CSS_PREFIX}-typography {
    display: block;
  }

  svg {
    transform: ${({ $isOpen }) => ($isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
    transition: transform 0.3s;
  }
`;

export const TriggerIcon = styled.span<{ $isOpen: boolean }>`
  display: flex;
  width: 45px;
  height: 45px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: ${({ $isOpen }) => ($isOpen ? BlueColors[20] : NeutralColors[10])};
  color: ${BlueColors[60]};
  transition: background 0.3s;

  svg {
    transform: none;
  }
`;

export const TriggerLabel = styled.span`
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
  padding: 0 12px;

  .${CSS_PREFIX}-typography:last-child {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 14px;
  }
`;

export const LoadingLabel = styled(Skeleton.Input).attrs({ size: 'small' })`
  margin-top: 2px;
`;

export const Panel = styled.div<{ $width: number }>`
  display: flex;
  width: ${({ $width }) => `${$width}px`};
  max-width: calc(100vw - 48px);
  flex-direction: column;
  gap: 12px;
`;
